type Feature = 'TEST_ROUTES' | 'CONTENTFUL_PREVIEW';

export const isFeatureEnabled = (feature: Feature) => {
  return process.env[`REACT_APP_FEATURE_${feature}`] === 'true';
};
